import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { mcpExposeMetadata, OKGeneric } from '../models';
import { PutUserProfileSchema, UserProfileSchema } from '../models/models.users';

extendZodWithOpenApi(z);
const c = initContract();

export const apiUsers = c.router({
  // implement use-user-profile
  getMyProfile: {
    method: 'GET',
    path: `/1.0/users/me`,
    description: 'Gets the authenticated users profile.',
    responses: {
      200: UserProfileSchema,
    },
    // Local-only: used by TIC MCP tooling to expose selected read endpoints as MCP tools.
    metadata: mcpExposeMetadata,
  },
  saveMyProfile: {
    method: 'PUT',
    path: `/1.0/users/me`,
    description: 'Updates the authenticated users profile.',
    body: PutUserProfileSchema,
    responses: {
      200: OKGeneric,
    },
  },
  deleteMe: {
    method: 'DELETE',
    path: `/1.0/users/me`,
    description: 'Delete the authenticated user (requires no accounts to exist).',
    body: null,
    responses: {
      200: OKGeneric,
    },
  },
});
